import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";
import axios from "axios";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { formatMoneda, seleccionarCampo, validaMonto, formatoMonto, validaSoloNumero } from "../../util/varios";
import { SuccessButton, DangerButton } from "../../ui/buttons/Button";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";
import moment from "moment";
import CatalogoObraRealizada from "../../catalogos/catalogoObraRealizada";


export default function AsignacionObras(props) {
    const btnAcepta = useRef();
    const btnCancela = useRef();
    var op = require('../../modulos/datos')
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [activate, setActivate] = useState(false);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });

    const txtIdObra = useRef();
    const txtIdObraAsi = useRef();
    const txtIdProve = useRef();
    const txtDescripcionObra = useRef();
    const txtRazonSocial = useRef();
    const txtRif = useRef();
    const txtFecha = useRef();
    const txtMonto = useRef();

    const salir = () => {
        props.onHideCancela();
    };

    const aceptar = () => {
        var sigue = true;
        if (txtFecha.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el la Fecha de asignación.', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        } else if (txtDescripcionObra.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir la Obra.', icono: 'informacion' });
            sigue = false;
            txtIdObra.current.focus();
        } else if (txtRazonSocial.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir la Contratista.', icono: 'informacion' });
            sigue = false;
            txtIdProve.current.focus();
        }
        if (sigue) {
            let body = {
                operacion: props.operacion,
                idobraasignada: txtIdObraAsi.current.value,
                idobra: txtIdObra.current.value,
                idproveedor: txtIdProve.current.value,
                fecha: txtFecha.current.value,
            };
            //alert(JSON.stringify(body))
            actualizarObra(body);
        }

    };

    const actualizarObra = (body) => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/ingenieria/actualizarobraasignada/${props.operacion}`;
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data) {
                        setActivate(false);
                        //setDesde(1);
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "El registro "+ response.data.rows[0].obraasignada_act + " fué actualizado.",
                            icono: "informacion",
                        });
                        /*if (props.operacion === 1) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Exito.",
                                texto:
                                    "La Obra ha sido asignada de manera satisfactoria.",
                                icono: "informacion",
                            });
                        } else if (props.operacion === 2) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Exito.",
                                texto:
                                    "La Obra ha sido modificada de manera satisfactoria.",
                                icono: "informacion",
                            });
                        } else if (props.operacion === 3) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Exito.",
                                texto:
                                    "La Obra ha sido ha sido Eliminada de manera satisfactoria.",
                                icono: "informacion",
                            });
                        }*/

                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        props.onHideCancela();
    };

    const seleccionarProveedor = (id) => {
        setMostrar2(false);
        let campos = "*";
        let nomtab = "proveedor";
        let nomid = "idproveedor";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data !== "") {
                        txtIdProve.current.value = response.data.idproveedor;
                        txtRazonSocial.current.value = response.data.razonsocial;
                        txtRif.current.value = response.data.rif;
                    } else {
                        txtIdProve.current.value = "";
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "No existe una Proveedor con este Codigo.",
                            icono: "informacion",
                        });
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });

                setActivate(false);
            });
    };

    const handleAceptaCatalogoObra = (values) => {
        setMostrar3(false);
        seleccionarObra(values[0].idobra);
        /*txtIdObra.current.value = values[0].idobra;
        txtDescripcionObra.current.value = values[0].descripcion.trim();
        txtMonto.current.value = formatMoneda(values[0].monto.toString().replace(/\./g, "").replace(".", ","), ",", ".", 2);*/
    };

    const validarObra = (event) => {
        event.preventDefault();

        validaSoloNumero(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                seleccionarObra(event.target.value);
            } else {
                txtIdObra.current.value = "";
                txtDescripcionObra.current.value = "";
                txtMonto.current.value = "";
            }
        }
    };

    const validarProveedor = (event) => {
        event.preventDefault();

        validaSoloNumero(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                seleccionarProveedor(event.target.value);
            } else {
                txtIdProve.current.value = "";
                txtRazonSocial.current.value = "";
                txtRif.current.value = "";
            }
        }
    };

    const seleccionarObra = (id) => {

        let endpoint = `${op.conexion}/api/contabilidadfis/selectobra?idefiscal=${idefiscal}&id=${id}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data !== "") {
                        setActivate(false);
                        if (response.data.asignada === 1 && props.operacion === 1){
                            txtIdObra.current.value = "";
                            txtIdObra.current.focus();
                            setMensaje({
                                mostrar: true,
                                titulo: "Notificación",
                                texto: "La Obra ya fue asignada.",
                                icono: "informacion",
                            });
                            
                            return;
                        }
                        txtIdObra.current.value = response.data.idobra;
                        txtDescripcionObra.current.value = response.data.descripcion;
                        txtMonto.current.value = formatMoneda(response.data.monto.toString().replace('.', ','), ',', '.', 2)
                      } else {
                        txtIdObra.current.value = "";
                        txtIdObra.current.focus();
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "No existe una Obra con este Codigo.",
                            icono: "informacion",
                        });

                        /*    txtDescripcion.current.value = ''; */
                        setActivate(false);
                    }
                }
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };



    return (
        <Modal
            size="lg"
            {...props}
            centered backdrop="static"
            keyboard={false}
            onShow={() => {
                if (props.operacion === 1) {
                    txtIdObraAsi.current.value = "0";
                    txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
                } else {
                    txtIdObraAsi.current.value = props.obra.idobraasignada;
                    seleccionarObra(props.obra.idobra);
                    seleccionarProveedor(props.obra.idproveedor);
                    txtFecha.current.value = moment.utc(props.obra.fechaasignacion).format("YYYY-MM-DD");
                }
            }}
        >
            <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
                <h3 className="fw-bold m-0">Asignación de Obras y Servicios</h3>
                <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap d-flex">
                <div className="col-3 m-0 p-0">
                    <Input label="Código:" readOnly ref={txtIdObraAsi} />
                </div>
                <div className="col-4 m-0 ml-auto p-0 pl-2">
                    <Input label='Fecha de Asignación:' type='date' ref={txtFecha} readOnly={props.operacion === 3 || props.operacion === 4 ? true : false} />
                </div>
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                    <legend className="float-none w-auto m-0">
                        Datos de la Obra
                    </legend>
                    <div className="col-3 m-0 p-0">
                        <SearchInput label='Código:'
                            readOnly={props.operacion === 1 ? false : true}
                            disabledButton={props.operacion === 1 ? false : true}
                            ref={txtIdObra}
                            onKeyUp={validarObra}
                            onBlur={validarObra}
                            onChange={() => { txtDescripcionObra.current.value = "", txtMonto.current.value = "" }}
                            onClickButton={() => {
                                setMostrar3(true);
                            }} />
                    </div>
                    <div className="col-9 m-0 mb-2 p-0 pl-2">
                        <Textarea readOnly label='Descripción:' style={{ height: 70 }} ref={txtDescripcionObra} />
                    </div>
                    <div className="col-4 m-0 ml-auto p-0 pl-2">
                        <Input readOnly label='Monto:' ref={txtMonto} />
                    </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                    <legend className="float-none w-auto m-0">
                        Datos del Contratista
                    </legend>
                    <div className="col-3 p-0 p-0">
                        <SearchInput label='Código:' 
                        ref={txtIdProve} 
                        readOnly={props.operacion === 3 || props.operacion === 4 ? true : false}
                        disabledButton={props.operacion === 3 || props.operacion === 4 ? true : false}
                        onKeyUp={validarProveedor}
                        onBlur={validarProveedor}
                        onClickButton={() => { setMostrar2(true) }} onChange={() => { txtRazonSocial.current.value = "", txtRif.current.value = "" }} />
                    </div>
                    <div className="col-7 m-0 p-0 pl-2">
                        <Input readOnly ref={txtRazonSocial} label='Nombre o Razón Social:' />
                    </div>
                    <div className="col-2 m-0 p-0 pl-2">
                        <Input readOnly ref={txtRif} label='RIF:' />
                    </div>
                </fieldset>
            </Modal.Body>
            <Modal.Footer>
                <SuccessButton ref={btnAcepta} onClick={aceptar}>
                    Aceptar
                </SuccessButton>
                <DangerButton ref={btnCancela} onClick={salir}>
                    Cancelar
                </DangerButton>
            </Modal.Footer>
            <Dimmer active={activate} inverted>
            </Dimmer>
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : setMensaje({
                            mostrar: false,
                            titulo: "",
                            texto: "",
                            icono: "",
                        });
                }}
            />
            <CatalogoProveedor
                show={mostrar2}
                onHideCancelaCatProv={() => {
                    setMostrar2(false);
                }}
                onHideAceptaCatProv={seleccionarProveedor}
                imp={1}
                tipo={1}
            />
            <CatalogoObraRealizada
                show={mostrar3}
                onHideCancelaCatalogo={() => {
                    setMostrar3(false);
                }}
                onHideAceptaCatalogo={handleAceptaCatalogoObra}
                compro={0}
            />
        </Modal>
    );
}